import {useTranslation} from 'react-i18next';
import Header from './components/Header/Header';
import UsersTable from './components/UsersTable';
import AddEditUserDialog from './components/AddEditUserDialog';
import {useUsersContext} from '../../../../context/users/UsersContextProvider';

function UsersMain() {
  const {i18n} = useTranslation();
  const isHebrew = i18n.language === 'heb';

  const {
    setSelectedUser,
    showAddEditDialog,
    setShowAddEditDialog,
    selectedUser,
  } = useUsersContext();

  const handleModalClose = () => {
    setSelectedUser(null);
    setShowAddEditDialog(false);
  };

  return (
    <>
      <div
        className={`flex-1 min-h-0 flex flex-col ${
          isHebrew ? 'rounded-tl-[32px]' : 'rounded-tr-[32px]'
        }`}>
        {/* Header */}
        <Header />

        <UsersTable />
      </div>

      <AddEditUserDialog
        open={showAddEditDialog}
        onClose={handleModalClose}
        selectedUser={selectedUser}
      />
    </>
  );
}

export default UsersMain;
